

























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Instructions extends Vue {
    count: number = 5;

    mounted() {
        this.ready();
    }

    ready() {
        if (this.count > 0) {
            window.setTimeout(() => {
                this.count -= 1;
                this.ready();
            }, 1000);
        }
    }
}
